export const CAMPANA_OBJETIVOS: { value: string; label: string }[] = [
  { value: "activar_demos",     label: "Activar demos" },
  { value: "reactivar_leads",   label: "Reactivar leads" },
  { value: "vender_rastro",     label: "Vender Rastro" },
  { value: "invitacion_evento", label: "Invitación a evento" },
  { value: "promocion",         label: "Promoción" },
];

export const OBJETIVO_LABELS: Record<string, string> =
  Object.fromEntries(CAMPANA_OBJETIVOS.map((o) => [o.value, o.label]));

export const TIPO_LABELS: Record<string, string> = {
  landing: "Landing", whatsapp: "WhatsApp", email: "Email",
};

export const ESTADO_LABELS: Record<string, string> = {
  borrador: "Borrador", activa: "Activa", finalizada: "Finalizada",
};
